import {RoomState, SensorAvailabilityStatus} from '@lib/infrastructure';
import {AttendeeAvailabilityStatus, MeetingRoomSuggestion, ScheduleInformationItem} from '../../entities';

const defaultValue: MeetingRoomSuggestion = {
  id: 'room id',
  score: 1,
  scheduleAvailability: AttendeeAvailabilityStatus.Unknown,
  scheduleInformation: [],
  suggestionId: 'suggestion id',
  sensorAvailability: SensorAvailabilityStatus.Unknown,
  numberOfPeople: 1,
  sensorStateTimestamp: new Date().toISOString(),
  state: RoomState.Unknown,
};

export const meetingRoomSuggestionBuilder = (suggestionDataParam?: MeetingRoomSuggestion) => {
  const data: MeetingRoomSuggestion = {...(suggestionDataParam ?? defaultValue)};

  return {
    withId: (id: string) => meetingRoomSuggestionBuilder({...data, id}),
    withScore: (score: number) => meetingRoomSuggestionBuilder({...data, score}),
    withScheduleAvailability: (scheduleAvailability: AttendeeAvailabilityStatus) =>
      meetingRoomSuggestionBuilder({...data, scheduleAvailability}),
    withScheduleInformation: (scheduleInformation: ScheduleInformationItem[]) =>
      meetingRoomSuggestionBuilder({...data, scheduleInformation}),
    withSuggestionId: (suggestionId?: string) => meetingRoomSuggestionBuilder({...data, suggestionId}),
    withSensorAvailability: (sensorAvailability: SensorAvailabilityStatus) =>
      meetingRoomSuggestionBuilder({...data, sensorAvailability}),
    withNumberOfPeople: (numberOfPeople?: number) => meetingRoomSuggestionBuilder({...data, numberOfPeople}),
    withSensorStateTimestamp: (sensorStateTimestamp?: Date) =>
      meetingRoomSuggestionBuilder({...data, sensorStateTimestamp: sensorStateTimestamp?.toISOString()}),
    withState: (state: RoomState) => meetingRoomSuggestionBuilder({...data, state}),

    build: () => ({...data}),
  };
};
